import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

const slide = new Swiper('.swiper-category', {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 11,
  spaceBetween: 11,
  breakpoints: {
    570: {
      centeredSlides: false,
      spaceBetween: 10,
      slidesPerView: 2,
    },
  },
});

export default slide;
